/** Soft pastels — visible variety without dominating the UI. */
const AVATAR_COLORS = [
  '#dbeafe',
  '#e0e7ff',
  '#ede9fe',
  '#fae8ff',
  '#fce7f3',
  '#ffe4e6',
  '#ffedd5',
  '#fef3c7',
  '#ecfccb',
  '#dcfce7',
  '#ccfbf1',
  '#cffafe',
  '#e0f2fe',
  '#f1f5f9',
  '#e2e8f0',
  '#ddd6fe',
  '#fbcfe8',
  '#bfdbfe',
];

/** Muted silhouette on light fills */
const AVATAR_ICON_FILL = 'rgba(71, 85, 105, 0.38)';

/** Dark UI — muted surfaces with warm brand tint */
const AVATAR_COLORS_DARK = [
  '#2a2622',
  '#2e2a26',
  '#322c28',
  '#2f2b27',
  '#353029',
  '#2a2e2c',
  '#2d2925',
  '#3a332c',
  '#2c2824',
  '#312b26',
  '#2e2c28',
  '#34302c',
  '#2b2723',
  '#38342f',
  '#2f2d29',
  '#3d352e',
  '#2a2826',
  '#36322e',
];

const AVATAR_ICON_FILL_DARK = 'rgba(232, 201, 168, 0.42)';

function hashSeed(value) {
  const s = String(value || '').trim();
  let h = 2166136261;
  for (let i = 0; i < s.length; i += 1) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

function pickColor(seed, dark = false) {
  const palette = dark ? AVATAR_COLORS_DARK : AVATAR_COLORS;
  return palette[hashSeed(seed) % palette.length];
}

const PLACEHOLDER_AVATAR_MARKERS = ['profile-pic.svg', 'social-profile-default.svg'];

/** True when the URL is empty or the app’s generic grey/default avatar asset. */
export function isPlaceholderProfilePictureUrl(url) {
  const u = String(url || '').trim();
  if (!u) return true;
  const lower = u.toLowerCase();
  if (/^https?:\/\//i.test(lower) && lower.includes('data:image')) {
    return true;
  }
  return PLACEHOLDER_AVATAR_MARKERS.some((marker) => lower.includes(marker));
}

/**
 * Data-URI SVG used when a user has not uploaded a profile picture.
 * Color is hashed from userId (then name) so the same person stays consistent.
 */
export function getUniqueDefaultAvatarDataUrl({ userId, name, displayName, theme } = {}) {
  const seed = String(userId || name || displayName || 'user').trim() || 'user';
  const dark = theme === 'dark';
  const bg = pickColor(seed, dark);
  const icon = dark ? AVATAR_ICON_FILL_DARK : AVATAR_ICON_FILL;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64">
    <circle cx="32" cy="32" r="32" fill="${bg}"/>
    <circle cx="32" cy="23" r="12" fill="${icon}"/>
    <path fill="${icon}" d="M10 58.5c0-12.4 9.8-22.5 22-22.5s22 10.1 22 22.5v5.5H10z"/>
  </svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
